import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { LoadTaxratesSuccessAction } from '../+state';
import { TaxrateDto } from '../dtos';

export class TaxrateValidator extends Validator<TaxrateDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return LoadTaxratesSuccessAction({ taxrates: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Taxrate', ErrorCode.NoTaxrates))
      .build();
  }
}
